import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IAppState } from '../state/app.state';
import { MLOService } from '../../Services/MLO/mlo.service';
import { Injectable } from '@angular/core';
import { switchMap, catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { EMLOActions, GetAllMLOs, GetAllMLODetails, SetMLOError, SetMLOSuccess,
   AddMLO, EdtMLO, GetMLOInternalCode, InactivateMLC, StartMLC, GetAllOlderMlcs, GetMLCById, GetAllClosedMlcs, EditClosedMlcs, CloseMLC, GetMLCByIdWithReleaseData, GetFormulaAndMlc,
   GetFormulaByIdForReleaseData, GetClosedMlcById, ActivateMLC, SendMailWhenCreateMLC,
    SendMailtoWarehouseUsers,GetCloseMlcUserAction } from '../actions/mlo.action';



@Injectable()
export class MLOEffects {

    getallmlos$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllMLOs>(EMLOActions.GetAllMLOs),
        map(action => action.payload),
        switchMap((payload : any) => {
            return this.mloService.getAllMLOs(payload).pipe(
                map((result: any) => {
                    return new GetAllMLODetails(result);
                }),
                catchError((err) => of(new SetMLOError(err)))
            );
        })
    ));


    getaddmlo$ = createEffect(() => this.actions$.pipe(
        ofType<AddMLO>(EMLOActions.AddMLO),
        map(action => action.payload),
        switchMap((payload : any) => {
            return this.mloService.addMLO(payload).pipe(
                map((result: any) => {
                    return new SetMLOSuccess(result, this.store);
                }),
                catchError((err) => of(new SetMLOError(err)))
            );
        })
    ));


    getedtmlo$ = createEffect(() => this.actions$.pipe(
        ofType<EdtMLO>(EMLOActions.EditMLO),
        map(action => action.payload),
        mergeMap((payload : any) => this.mloService.editMLO(payload)
        .pipe(map((result2: any) => ({ type: 'Set MLO Success', payload: result2 })),
          catchError((err) => of({ type: 'Set MLO Error', payload:err }))
        )
      )
    ));


    getMloCode$ = createEffect(() => this.actions$.pipe(
        ofType<GetMLOInternalCode>(EMLOActions.GetMLOInternalCode),
        map(action => action.payload),
        mergeMap((payload : any) => this.mloService.getInternalCode(payload)
        .pipe(map((result2: any) => ({ type: '[MLO] Get MLO Internal Code Success', payload: result2 })),
          catchError((err) => of({ type: 'Set MLO Error', payload:err }))
        )
      )
    ));


    setMloInactiavte$ = createEffect(() => this.actions$.pipe(
        ofType<InactivateMLC>(EMLOActions.InactivateMLC),
        map(action => action.payload),
        mergeMap((payload : any) => this.mloService.inActivateMLC(payload)
        .pipe(map((result2: any) => ({ type: '[MLO] Inactivate MLC Success', payload: result2 })),
          catchError((err) => of({ type: 'Set MLO Error', payload:err }))
        )
      )
    ));


    startMlo$ = createEffect(() => this.actions$.pipe(
        ofType<StartMLC>(EMLOActions.StartMLC),
        map(action => action.payload),
        mergeMap((payload : any) => this.mloService.startMLC(payload)
        .pipe(map((result2: any) => ({ type: '[MLO] Start MLC Success', payload: result2 })),
          catchError((err) => of({ type: 'Set MLO Error', payload:err }))
        )
      )
    ));

    closeMlo$ = createEffect(() => this.actions$.pipe(
        ofType<CloseMLC>(EMLOActions.CloseMLC),
        map(action => action.payload),
        mergeMap((payload : any) => this.mloService.closeMLC(payload)
        .pipe(map((result2: any) => ({ type: '[MLO] Close MLC Success', payload: result2 })),
          catchError((err) => of({ type: 'Set MLO Error', payload:err }))
        )
      )
    ));

    getAllOlderMlcs$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllOlderMlcs>(EMLOActions.GetAllOlderMlcs),
        map(action => action.payload),
        mergeMap((payload : any) => this.mloService.getAllOlderMlcs(payload)
        .pipe(map((result2: any) => ({ type: '[MLO] Get All Older MLCs Success', payload: result2 })),
          catchError((err) => of({ type: '[MLO] Get All Older MLCs Error', payload:err }))
        )
      )
    ));

    getMlcById$ = createEffect(() => this.actions$.pipe(
        ofType<GetMLCById>(EMLOActions.GetMLCById),
        map(action => action.payload),
        mergeMap((payload : any) => this.mloService.getMlcById(payload)
        .pipe(map((result: any) => ({ type: '[MLC] Set MLC By Id Success', payload: result })),
          catchError((err) => of({ type: '[MLC] Set MLC By Id Error', payload:err }))
        )
      )
    ));

    getAllClosedMlcs$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllClosedMlcs>(EMLOActions.GetAllClosedMlcs),
        map(action => action.payload),
        mergeMap((payload : any) => this.mloService.getAllClosedMlcs(payload)
        .pipe(map((result2: any) => ({ type: '[MLC] Get All Closed MLCs Success', payload: result2 })),
          catchError((err) => of({ type: '[] Get All Closed MLCs Error', payload:err }))
        )
      )
    ));

    getClosedMlcById$ = createEffect(() => this.actions$.pipe(
        ofType<GetClosedMlcById>(EMLOActions.GetClosedMlcById),
        map(action => action.payload),
        mergeMap((payload : any) => this.mloService.getClosedMlcById(payload)
        .pipe(map((result2: any) => ({ type: '[MLC] Get Closed MLCs By Id Success', payload: result2 })),
          catchError((err) => of({ type: '[] Get Closed MLCs By Id Error', payload:err }))
        )
      )
    ));

    activateMLC$ = createEffect(() => this.actions$.pipe(
        ofType<ActivateMLC>(EMLOActions.ActivateMLC),
        map(action => action.payload),
        mergeMap((payload : any) => this.mloService.activateClosedMLC(payload)
        .pipe(map((result2: any) => ({ type: '[MLC] Get Activate Closed MLC Success', payload: result2 })),
          catchError((err) => of({ type: '[] Get Activate Closed MLC Error', payload:err }))
        )
      )
    ));

    editClosedMlcs$ = createEffect(() => this.actions$.pipe(
        ofType<EditClosedMlcs>(EMLOActions.EditClosedMlcs),
        map(action => action.payload),
        mergeMap((payload : any) => this.mloService.editClosedMlcs(payload)
        .pipe(map((result2: any) => ({ type: '[MLC] Get Edit Closed MLCs Success', payload: result2 })),
          catchError((err) => of({ type: '[] Get Edit Closed MLCs Error', payload:err }))
        )
      )
    ));

    getMlcByIdWithReleaseData$ = createEffect(() => this.actions$.pipe(
        ofType<GetMLCByIdWithReleaseData>(EMLOActions.GetMLCByIdWithReleaseData),
        map(action => action.payload),
        mergeMap((payload : any) => this.mloService.getMlcByIdWithReleaseData(payload)
        .pipe(map((result2: any) => ({ type: '[MLC] Set MLC By Id With Releasedata Success', payload: result2 })),
          catchError((err) => of({ type: '[MLC] Set MLC By Id With Releasedata Error', payload:err }))
        )
      )
    ));

    getFormulaAndMlc$ = createEffect(() => this.actions$.pipe(
        ofType<GetFormulaAndMlc>(EMLOActions.GetFormulaAndMlc),
        map(action => action.payload),
        mergeMap((payload : any) => this.mloService.getFormulaAndMlcs(payload)
        .pipe(map((result2: any) => ({ type: '[MLC] Get Formula and Mlc Success', payload: result2 })),
          catchError((err) => of({ type: '[] Get Formula and Mlc Error', payload:err }))
        )
      )
    ));

    getFormulaByIdForReleaseData$ = createEffect(() => this.actions$.pipe(
        ofType<GetFormulaByIdForReleaseData>(EMLOActions.GetFormulaByIdForReleaseData),
        map(action => action.payload),
        mergeMap((payload : any) => this.mloService.getFormulaByIdForReleaseData(payload)
        .pipe(map((result2: any) => ({ type: '[MLC] Get Formula By Id For Release data Success', payload: result2 })),
          catchError((err) => of({ type: '[] Get Formula By Id For Release data Error', payload:err }))
        )
      )
    ));

    sendMailWhenCreateMLC$ = createEffect(() => this.actions$.pipe(
        ofType<SendMailWhenCreateMLC>(EMLOActions.SendMailWhenCreateMLC),
        map(action => action.payload),
        mergeMap((payload : any) => this.mloService.sendMailWhenCreateMLC(payload)
        .pipe(map((result2: any) => ({ type: '[MLC] Get send Mail When Create MLC Success', payload: result2 })),
          catchError((err) => of({ type: '[] Get send Mail When Create MLC Error', payload:err }))
        )
      )
    ));

    sendMailtoWarehouseUsers$ = createEffect(() => this.actions$.pipe(
        ofType<SendMailtoWarehouseUsers>(EMLOActions.SendMailtoWarehouseUsers),
        map(action => action.payload),
        mergeMap((payload : any) => this.mloService.sendMailtoWarehouseUsers(payload)
        .pipe(map((result2: any) => ({ type: '[MLC] Get send Mail to Warehouse Users Success', payload: result2 })),
          catchError((err) => of({ type: '[] Get send Mail to Warehouse Users Error', payload:err }))
        )
      )
    ));
    //
    // getCloseMlcUserAction$ = createEffect(() => this.actions$.pipe(
    //     ofType<GetCloseMlcUserAction>(EMLOActions.GetCloseMlcUserAction),
    //     map(action => action.payload),
    //     mergeMap((payload : any) => this.mloService.getCloseMlcUserAction(payload)
    //     .pipe(map((result: any) => ({ type: '[MLC] Get Close Mlc UserAction Success', payload: result })),
    //       catchError((err) => of({ type: '[] Get Close Mlc UserAction Error', payload:err }))
    //     )
    //   )
    // );

    getCloseMlcUserAction$ = createEffect(() => this.actions$.pipe(
        ofType<GetCloseMlcUserAction>(EMLOActions.GetCloseMlcUserAction),
        map(action => action.payload),
        mergeMap((payload : any) => this.mloService.getCloseMlcUserAction(payload)
        .pipe(map((result: any) => ({ type: '[MLC] Get Close Mlc UserAction Success', payload: result, from: 'getCloseMlcUserAction' })),
          catchError((err) => of({ type: '[] Get Close Mlc UserAction Error', payload:err, from: 'getCloseMlcUserAction' }))
        )
      )
    ));
    constructor( private actions$: Actions,
        private store: Store<IAppState>,
        private mloService: MLOService
    ){}
}
